export const DATA_WAREHOUSE_PREVIEW_KEY = 'hightouch-integration';
